import { render, staticRenderFns } from "./Exemplo.vue?vue&type=template&id=c1d6ce00&scoped=true&"
import script from "./Exemplo.vue?vue&type=script&lang=js&"
export * from "./Exemplo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1d6ce00",
  null
  
)

export default component.exports